import * as React from 'react';
import { useGetProductsBySkus } from '@grandvisionhq/fun-search';
import { ProductBlockRow } from '@grandvisionhq/lib-visuals';
import { ProductListingRowBlock } from './components/ProductListingRowBlock/ProductListingRowBlock.js';

const ProductListingRow = ({ skus  })=>{
    const { listingProducts , loading  } = useGetProductsBySkus({
        skus
    });
    return /*#__PURE__*/ React.createElement(ProductBlockRow, {
        isLoading: loading
    }, listingProducts === null || listingProducts === void 0 ? void 0 : listingProducts.map((listingProduct)=>/*#__PURE__*/ React.createElement(ProductListingRowBlock, {
            key: listingProduct.slug,
            listingProduct: listingProduct
        })
    ));
};

export { ProductListingRow };
//# sourceMappingURL=ProductListingRow.js.map
